<div class="container-fluid mt-3">
    <div class="row">
        <div class="col-lg-7">
            <div class="card">
                <div class="card-header d-flex align-items-center">
                    <strong>{{ 'route.user_management' | transloco }}</strong>
                    <button class="btn btn-sm btn-outline-secondary ml-auto" (click)="load()">{{ 'common.update' | transloco }}</button>
                </div>
                <div class="card-body">
                    <p class="text-muted" *ngIf="loading">{{ 'shell.loading_ellipsis' | transloco }}</p>
                    <wj-flex-grid [itemsSource]="cv" [isReadOnly]="true" [selectionMode]="'Row'"
                                  [headersVisibility]="'Column'" style="min-height:320px; max-height:520px" *ngIf="!loading">
                        <wj-flex-grid-column [header]="'shell.user' | transloco" [binding]="'name'" [width]="'*'"></wj-flex-grid-column>
                        <!-- パスワードリセットの送信先 (issue #171) -->
                        <wj-flex-grid-column [header]="'shell.mail' | transloco" [binding]="'email'" [width]="'1.5*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'shell.role' | transloco" [binding]="'roleNames'" [width]="'2*'"></wj-flex-grid-column>
                        <wj-flex-grid-column [header]="'shell.actions' | transloco" [width]="90" [align]="'center'" [isReadOnly]="true">
                            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                <button class="btn btn-sm btn-link p-0" (click)="edit(cell.item)">{{ 'common.edit' | transloco }}</button>
                            </ng-template>
                        </wj-flex-grid-column>
                    </wj-flex-grid>
                    <div class="d-flex align-items-center mt-2" *ngIf="!loading">
                        <wj-collection-view-pager [cv]="cv"></wj-collection-view-pager>
                        <span class="ml-3 text-muted">{{ 'shell.total_count' | transloco: {count: cv ? cv.totalItemCount : 0} }}</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-5">
            <div class="card" *ngIf="editingRid">
                <div class="card-header"><strong>{{ 'shell.edit_user' | transloco }}</strong> — {{ editingName }}</div>
                <div class="card-body">
                    <!-- パスワードリセットの送信先。未登録だとリセットを受け取れない (issue #171) -->
                    <div class="form-group">
                        <label>{{ 'shell.email_address' | transloco }}</label>
                        <input type="email" class="form-control" [class.is-invalid]="!emailValid"
                               [(ngModel)]="email" [placeholder]="'shell.email_placeholder_reset' | transloco">
                        <small class="form-text text-muted" *ngIf="emailValid">{{ 'shell.email_unregistered_hint' | transloco }}</small>
                        <small class="form-text text-danger" *ngIf="!emailValid">{{ 'shell.email_invalid_format' | transloco }}</small>
                    </div>
                    <label class="mt-2"><strong>{{ 'shell.role' | transloco }}</strong></label>
                    <div class="form-check" *ngFor="let role of allRoles">
                        <label class="form-check-label">
                            <input type="checkbox" class="form-check-input" [(ngModel)]="checked[role.rid]"> {{ role.name }}
                        </label>
                    </div>
                    <div class="mt-3">
                        <button class="btn btn-primary mr-2" (click)="save()">{{ 'common.save' | transloco }}</button>
                        <button class="btn btn-outline-secondary" (click)="cancel()">{{ 'common.cancel' | transloco }}</button>
                    </div>
                </div>
            </div>
            <div class="card" *ngIf="!editingRid">
                <div class="card-body text-muted text-center py-5">
                    {{ 'shell.edit_user_hint' | transloco }}
                </div>
            </div>
        </div>
    </div>
</div>
